import { fork } from 'redux-saga/effects';

import deleteRuleSaga from './deleteRuleFromEditPageSaga';

export default [fork(deleteRuleSaga)];
